import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Readers } from '../../../asset/utils/Readers';
import { SlideMenuList } from '../../../asset/utils/SlideMenuList';
import { StudentBook } from '../../../asset/utils/StudentBook';
import { WorkBook } from '../../../asset/utils/WorkBook';
import { setCurrentAnimation, setCurrentContent, setCurrentMenu, setCurrentPage, setCurrentUnit } from '../../../store/BookSlice';
import { resetCard, setCardUnit } from '../../../store/CardSlice';
import { closePop, setPopAudio, setPopCard, setPopGame, setPopVideo } from '../../../store/CommonSlice';
import { resetGame } from '../../../store/GameSlice';
import { setAnimation, setAnimationMenu, setBookmark, setContent, setContentMenu, setMenu, setUnit } from '../../../store/MenuSlice';
import { resetTrack } from '../../../store/TrackSlice';
import { resetCurrentVideo, resetVideo, setVideoSrc } from '../../../store/VideoSlice';
import { Anchor } from '../../_atoms/Anchor';
import { Heading } from '../../_atoms/Heading';
import { Item } from '../../_atoms/Item';
import { List } from '../../_atoms/List';

export const SlideList = (props) => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const [top, setTop] = useState(0);

  const onContentMenuSetting = (first, second) => { 
    dispatch(closePop());
    dispatch(resetTrack());
    dispatch(resetVideo());
    dispatch(resetCard());
    dispatch(resetGame());
    
    if (state.menu.menu === first && state.menu.content === second) {
      dispatch(setContentMenu(!state.menu.content_menu));
    } else {
      dispatch(setContentMenu(true));
    }

    dispatch(setMenu(first));
    dispatch(setContent(second));
    dispatch(setUnit(null));
    dispatch(setAnimationMenu(false));
    
    // Resource
    if (first === 1) {
      // Audio Track
      if (second === 0) {
        dispatch(setPopAudio(!state.common.pop_audio));
        dispatch(resetTrack());
      // game
      } else if (second === 3) {
        dispatch(setPopGame(!state.common.pop_game));
      }
    }
  };
  
  const onUnitMenuSetting = (e, first, second, unit) => {
    let parentLi = e.currentTarget.parentNode;
    setTop(Math.abs(parentLi.parentNode.scrollTop - parentLi.offsetTop));

    if (state.menu.menu === 1 && state.menu.content === 1) {
      dispatch(setAnimationMenu(true));
      
      if (state.menu.unit !== unit) {
        dispatch(setAnimation(null));
      }
    } else {
      dispatch(setAnimationMenu(false));
    }
    
    dispatch(setContentMenu(true));
    dispatch(setUnit(unit));
    dispatch(setCurrentMenu(first));
    dispatch(setCurrentContent(second));
    dispatch(setCurrentUnit(unit));

    // BookList
    if (first === 0) {
      // StudentBook
      if (second === 0) {
        dispatch(setCurrentPage(StudentBook[state.book.current_book].unit[unit]));
      // WorkBook
      } else if (second === 1) {
        dispatch(setCurrentPage(WorkBook[state.book.current_book].unit[unit]));
      // Readers
      } else if (second === 2) {
        dispatch(setCurrentPage(Readers[state.book.current_book].unit[unit]));
      }
    // Resource
    } else if (first === 1) {
      // flashCard 
      if (second === 2) {
        if (state.card.unit !== unit) {
          dispatch(resetCard());
          dispatch(setPopCard(true));
          dispatch(setCardUnit(unit));
        }
      } 
    }
  };

  const onUnitBookmarkMenuSetting = (first, second, page) => {
    dispatch(setAnimationMenu(false));
  
    dispatch(setContentMenu(true));
    dispatch(setUnit(null));
    dispatch(setCurrentMenu(first));
    dispatch(setCurrentContent(second));
    dispatch(setCurrentUnit(null));
    dispatch(setBookmark(page));
    dispatch(setCurrentPage(page));
  };

  const onAnimationMenuSetting = (num) => {
    dispatch(resetCurrentVideo());
    dispatch(setAnimation(num));
    dispatch(setCurrentAnimation(num));
    dispatch(setPopVideo(true), resetTrack(), resetCard());
    dispatch(setVideoSrc(state.book.current_unit === (SlideMenuList[state.book.current_book][1].depth3[1].length - 1) ? (state.book.current_book + 1) + '_R_' + (num + 1) : (state.book.current_book + 1) +'_'+ (state.book.current_unit + 1) + '_' + (num + 1)));
  };

  return (
    <List order={false} type="aside">
      <Heading level={1} type="aside">{props.list.depth1}</Heading>
      {props.list && (props.list.depth2).map((depth2, idx) => {
        return (
          <Item type="aside">
            <Anchor 
              type="aside" 
              onClick={() => onContentMenuSetting(props.first, idx)}
              className={((state.common.pop_audio && props.first === 1 && idx === 0) || (state.menu.content_menu && props.first === state.menu.menu && idx === state.menu.content)) && 'act'}
            >
              {depth2}
            </Anchor>
            {(props.first === 0 || props.first === 2 || (props.first === 1 && (idx === 1 || idx === 2))) && (
              <List order={false} type="asideIn" className={state.menu.content_menu && props.first === state.menu.menu && idx === state.menu.content && 'act'}>
                {props.first === 2 ? 
                  state.book.bookmark && (state.book.bookmark.filter((mark) => mark.book === state.book.current_book && mark.content === idx)).map((bookmark, i) => {
                    return (
                      <Item type="asideIn">
                      <Anchor 
                        type="asideIn" 
                        onClick={(e) => onUnitBookmarkMenuSetting(props.first, idx, bookmark.page)} 
                        className={state.menu.content_menu && props.first === state.menu.menu && idx === state.menu.content && bookmark.page === state.menu.bookmark && 'act'}
                      >
                        {idx === 0 ? 'StudentBook_' : (idx === 1 ? 'WorkBook_' : 'Readers_')}{bookmark.page}
                      </Anchor>
                      </Item>
                    )
                  })
                  :
                  props.list && (props.list.depth3[idx]).map((depth3, i) => {
                    return (
                      <Item type="asideIn">
                        <Anchor 
                          type="asideIn"
                          onClick={(e) => onUnitMenuSetting(e, props.first, idx, i)} 
                          className={state.menu.content_menu && props.first === state.menu.menu && idx === state.menu.content && i === state.menu.unit && 'act'}
                        >
                          {depth3}
                        </Anchor>
                      </Item>
                    )
                  })
                }
              </List>
            )}
            {(props.first === 1 && idx === 1) && (
              <List order={false} type='animation' top={top + 'px'} className={state.menu.animation_menu ? 'act' : ''}>
                {props.list.depth4[state.menu.unit] && props.list.depth4[state.menu.unit].map((animation, num) => {
                  return (
                    <Item type="animation">
                      <Anchor 
                        type="animation"
                        onClick={() => onAnimationMenuSetting(num)}
                        className={state.menu.animation_menu && num === state.menu.animation && 'act'}
                      >
                        {animation}
                      </Anchor>
                    </Item>
                  )
                })}
              </List>
            )}
          </Item>
        )
      })}
    </List>
  );
};

SlideList.propTypes = {
    
};

SlideList.defaultProps = {
  list : {
    depth1 : 'Book List',
    depth2 : ['Student Book', 'Work Book', 'Readers'],
    depth3 : [['unit 1', 'unit 2', 'unit 3', 'unit 4', 'unit 5', 'unit 6', 'unit 7', 'unit 8'], ['unit 1', 'unit 2', 'unit 3', 'unit 4', 'unit 5', 'unit 6', 'unit 7', 'unit 8', 'unit 9'], ['unit 1', 'unit 2', 'unit 3']]
  }
}